import {SlideData} from "./SlideData";
import React from "react";


export const SlideContent = (props: {slide: SlideData, onClick: Function}) => {


    const handleClick = () => {
        props.onClick();
    }

    return (
        <div className="info" data-party={props.slide.title}>
            <span>{props.slide.price}</span>
            <p className="slide-descr">{props.slide.description}</p>
            <div className="info__button-wrap">
                <button className="btn-call" onClick={handleClick} aria-label="Заказать звонок">
                    Заказать звонок
                </button>
            </div>
        </div>
    )
};
